/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Salty_White_Baboon_JoltInputs */

const fr_salty_white_baboon_jolt = /** @type {(inputs: Salty_White_Baboon_JoltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minutes`)
};

/**

* @param {Salty_White_Baboon_JoltInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const salty_white_baboon_jolt = /** @type {((inputs?: Salty_White_Baboon_JoltInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Salty_White_Baboon_JoltInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_salty_white_baboon_jolt(inputs)
});